
const TitleSection = (props: any) => {

  let title = props.title ?? '';


  return (
    <div className="col-lg-12 pt-1 mb-0 text-center">
      <h1>{title}</h1>
    </div>
  )
}

export default TitleSection;
